module.exports = __webpack_public_path__ + "static/img/4.a2bf615.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/7/1/14/zh/4.png
// module id = Zi6B
// module chunks = 0